import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { Input } from "@/components/ui/input";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/member";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Register() {
  const { t, L } = useLang();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data.user);
      toast.success(L("注册成功！已赠送 100 积分", "Welcome! 100 points added"));
      navigate("/member");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="bg-white fk-border-thick rounded-2xl p-8 fk-shadow">
        <h1 className="font-display text-4xl">{t("register")}</h1>
        <p className="text-black/60 text-sm mt-1">{L("加入放空会员，领取优惠与礼品", "Join Fangkong members for coupons & gifts")}</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <Input required placeholder={t("name")} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="reg-name" className="fk-border rounded-lg" />
          <Input required type="email" placeholder={t("email")} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="reg-email" className="fk-border rounded-lg" />
          <Input required type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reg-password" className="fk-border rounded-lg" />
          <button disabled={loading} data-testid="reg-submit" className="w-full fk-border rounded-full px-6 py-3 font-semibold bg-[#FF5757] text-white fk-lift disabled:opacity-50">
            {loading ? "…" : t("register")}
          </button>
        </form>
        <div className="my-4 flex items-center gap-3 text-black/40 text-xs font-mono-fk"><div className="flex-1 h-px bg-black/15" />OR<div className="flex-1 h-px bg-black/15" /></div>
        <button onClick={googleLogin} data-testid="reg-google" className="w-full fk-border rounded-full px-6 py-3 font-semibold bg-white fk-lift flex items-center justify-center gap-2">
          <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4" /> {L("使用 Google 注册", "Continue with Google")}
        </button>
        <p className="text-sm text-center mt-5 text-black/60">
          {L("已有账号？", "Have an account?")} <Link to="/login" className="underline font-semibold">{t("login")}</Link>
        </p>
      </div>
    </div>
  );
}
